import React, {useState} from "react";
import { Button } from "../../ui";
import { CustomForm, CustomModal } from "../../components";
import { Form } from "react-bootstrap";
import {
  useFetchAllsmtpSettingQuery,
  useFetchAllsmtpStaticsQuery,
  useUpdateSmtpMutation
} from "../../store/api/apiSlice";
import { toast } from "react-toastify";
const SettingsManagement = () => {
  
      const { data: smtpSettingData = { smtp: [] }, refetch: refetchSm}=useFetchAllsmtpSettingQuery()
      console.log("smtpSettingData",smtpSettingData)
      const { data: smtpStaticsData = { smtp: [] }, refetch: refetchSd}=useFetchAllsmtpStaticsQuery()
      console.log("smtpStaticsData",smtpStaticsData)
      const[updateSmtp]=useUpdateSmtpMutation();
    const [isModalOpen,setIsModalOpen]=useState(false)
    const [smtpData, setSmtpData] = useState({
      smtp_host: "",
      smtp_port: "",
      smtp_username: "",
      smtp_password: "",
      sender_email: ""
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setSmtpData(prevState => ({
        ...prevState,
        [name]: value
      }));
    };

const closeModal=()=>{
setIsModalOpen(false)
setSmtpData({ // Reset the fields to initial values
  smtp_host: "",
  smtp_port: "",
  smtp_username: "",
  smtp_password: "",
  sender_email: ""
});
}

    const handleOpenSetting=()=>{
        setIsModalOpen(true)
    }

    const handleSubmit = async (e) => {
      e.preventDefault();
     
      try {
        await updateSmtp({smtpData}); 
        setSmtpData({ 
          smtp_host: "",
          smtp_port: "",
          smtp_username: "",
          smtp_password: "",
          sender_email: ""
        });
        setIsModalOpen(false);
        toast.success("SMTP Setting Data Updated");
      } catch (error) {
        setIsModalOpen(false);
        toast.error("SMTP Setting Data Not Updated");
      }
    };
  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <h3 className="mb-4">Settings Management Todo</h3>
      </div>

      {/* SMTP Settings Container */}
      <div className="smtp-settings-container">
        <h4>SMTP Settings</h4>
        <div className="smtp-settings">
          <div className="smtp-row">
            <span>SMTP Server:</span>
            <span>smtp.example.com</span>
          </div>
          <div className="smtp-row">
            <span>SMTP Port:</span>
            <span>587</span>
          </div>
          <div className="smtp-row">
            <span>Username:</span>
            <span>user@example.com</span>
          </div>
          <div className="smtp-row">
            <span>Password:</span>
            <span>********</span>
          </div>
          <div className="smtp-row">
            <span>Sender Email:</span>
            <span>sender@example.com</span>
          </div>
        </div>
        <Button className="edit-button" onClick={handleOpenSetting}>Edit</Button>
      </div>

      {/* SMTP Statistics Container */}
      <div className="smtp-statistics-container" style={{ marginTop: "20px" }}>
        <h4>SMTP Statistics</h4>
        <div className="smtp-statistics">
          <div className="smtp-row">
            <span>Total Emails Success:</span>
            <span>XX</span>
          </div>
          <div className="smtp-row">
            <span>Total Emails Failed:</span>
            <span>XX</span>
          </div>
          <div className="smtp-row">
            <span>Success Today:</span>
            <span>XX</span>
          </div>
          <div className="smtp-row">
            <span>Failed Today:</span>
            <span>XX</span>
          </div>
        </div>
       
      </div>
      <CustomModal  isOpen={isModalOpen} onClose={closeModal}>
        <div style={{ padding: "1rem", maxHeight: "80vh", overflowY: "auto" }}>
          <h4
            style={{
              fontSize: "1.2rem",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            SMTP Settings
          </h4>
          <CustomForm onSubmit={handleSubmit} >
        

            <Form.Group>
              <Form.Label>SMTP Server</Form.Label>
              <Form.Control
                  name="smtp_host"
                  value={smtpData.smtp_host}
                  onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>SMTP Port</Form.Label>
              <Form.Control
               name="smtp_port"
               value={smtpData.smtp_port}
               onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Username</Form.Label>
              <Form.Control
                   name="smtp_username"
                   value={smtpData.smtp_username}
                   onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="smtp_password"
                value={smtpData.smtp_password}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Sender Email</Form.Label>
              <Form.Control
               name="sender_email"
               value={smtpData.sender_email}
               onChange={handleChange}
              />
            </Form.Group>
            
            <div className="d-flex justify-content-end mt-3">
              
              <Button  variant="primary" type="submit">
                Update
              </Button>
            </div>
          </CustomForm>
        </div>
      </CustomModal>
     
    </div>
  );
};

export default SettingsManagement;